export default {
      id: "arrow_left-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#arrow_left",
      toString: function () {
        return this.url;
      }
    }